import STRINGS from "../../../provider-management/utils/strings";

export const AVAILABLE_LIMIT = STRINGS.DEFAULT_PAGINATION_LIMIT;
export const PROVIDED_LIMIT = STRINGS.DEFAULT_PROVIDED_SERVICES_PAGINATION_LIMIT;

export function getServiceId(service) {
  return service?.id ?? service?.service?.id ?? null;
}

export function getServiceCode(service = {}) {
  return (
    service?.serviceCode ??
    service?.service_code ??
    service?.service?.serviceCode ??
    service?.service?.service_code ??
    ""
  );
}

export function getServiceName(service = {}) {
  return (
    service?.serviceName ??
    service?.service_name ??
    service?.service?.serviceName ??
    service?.service?.service_name ??
    ""
  );
}

export function getServiceDescription(service = {}) {
  return service?.description ?? service?.service?.description ?? STRINGS.NO_SERVICE_DESCRIPTION;
}

export function normalizeAvailableService(service = {}) {
  return {
    ...service,
    id: getServiceId(service),
    serviceCode: getServiceCode(service),
    serviceName: getServiceName(service),
    description: getServiceDescription(service),
    serviceType: STRINGS.SERVICE_TYPE.AVAILABLE,
  };
}

export function normalizeProvidedService(item = {}) {
  const baseService = item?.service ?? item;
  return {
    ...baseService,
    id: getServiceId(baseService),
    serviceCode: getServiceCode(baseService),
    serviceName: getServiceName(baseService),
    description: getServiceDescription(baseService),
    serviceType: STRINGS.SERVICE_TYPE.PROVIDED,
  };
}
